/* RZX Eyewear — assets/rzx-theme.js */
'use strict';

/* ── Announcement close ── */
const annClose = document.getElementById('rzxAnnClose');
const annBar   = document.getElementById('rzxAnn');
const header   = document.querySelector('.rzx-header');
if (annClose && annBar) {
  annClose.addEventListener('click', function () {
    annBar.style.display = 'none';
    if (header) header.classList.add('no-ann');
  });
}

/* ── Mobile menu ── */
const mobToggle = document.getElementById('rzxMobToggle');
const mobPanel  = document.getElementById('rzxMobPanel');
const mobBg     = document.getElementById('rzxMobBg');
const mobClose  = document.getElementById('rzxMobClose');
function openMob()  { if(mobPanel) mobPanel.classList.add('open'); if(mobBg) mobBg.classList.add('open'); if(mobToggle) mobToggle.setAttribute('aria-expanded','true'); }
function closeMob() { if(mobPanel) mobPanel.classList.remove('open'); if(mobBg) mobBg.classList.remove('open'); if(mobToggle) mobToggle.setAttribute('aria-expanded','false'); }
if (mobToggle) mobToggle.addEventListener('click', openMob);
if (mobClose)  mobClose.addEventListener('click', closeMob);
if (mobBg)     mobBg.addEventListener('click', closeMob);
document.querySelectorAll('#rzxMobPanel a, #rzxMobPanel button').forEach(function(el) {
  el.addEventListener('click', closeMob);
});

/* ── FAQ accordion ── */
document.querySelectorAll('.rzx-faq__q').forEach(function(btn) {
  btn.addEventListener('click', function () {
    var item   = btn.parentElement;
    var isOpen = item.classList.toggle('open');
    btn.setAttribute('aria-expanded', isOpen);
  });
});

/* ── Hero parallax ── */
var heroMotion = document.getElementById('rzxHeroMotion');
var heroImg    = document.getElementById('rzxHeroImg');
if (heroMotion && heroImg) {
  heroMotion.addEventListener('mousemove', function (e) {
    var r = heroMotion.getBoundingClientRect();
    var x = (e.clientX - r.left) / r.width  - .5;
    var y = (e.clientY - r.top)  / r.height - .5;
    heroImg.style.transform = 'rotateY(' + (x * 11) + 'deg) rotateX(' + (y * -9) + 'deg) translateZ(12px)';
  });
  heroMotion.addEventListener('mouseleave', function () {
    heroImg.style.transform = 'none';
  });
}

/* ── Scroll reveal ── */
var observer = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('in'); });
}, { threshold: 0.1 });
document.querySelectorAll('.rzx-reveal').forEach(function(el) { observer.observe(el); });

/* ── Cart count update (Dawn-compatible) ── */
document.addEventListener('cart:updated', function(e) {
  var badges = document.querySelectorAll('[data-rzx-cart-count]');
  badges.forEach(function(b) { b.textContent = e.detail && e.detail.cart ? e.detail.cart.item_count : ''; });
});

/* ── Cart page controls ── */
(function () {
  var root = document.querySelector('[data-rzx-cart]');
  if (!root) return;

  var status = root.querySelector('[data-rzx-cart-status]');
  var busy = false;

  function setStatus(message) {
    if (status) status.textContent = message || '';
  }

  function setBusy(isBusy) {
    busy = isBusy;
    root.classList.toggle('is-loading', isBusy);
    root.querySelectorAll('button, input').forEach(function (el) {
      el.disabled = isBusy;
    });
  }

  function updateBadges(cart) {
    document.querySelectorAll('#rzxCartCount, [data-rzx-cart-count]').forEach(function (badge) {
      badge.textContent = cart && typeof cart.item_count === 'number' ? cart.item_count : '';
    });
  }

  function changeCart(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart update failed');
      return response.json();
    });
  }

  function reloadCart(cart) {
    updateBadges(cart);
    window.location.reload();
  }

  function updateLine(row, quantity, message) {
    if (!row || busy) return;
    var key = row.getAttribute('data-line-key');
    if (!key) return;

    setBusy(true);
    setStatus(message || 'Updating cart...');
    changeCart(key, quantity)
      .then(reloadCart)
      .catch(function () {
        setBusy(false);
        setStatus('Could not update cart. Please try again.');
      });
  }

  root.addEventListener('click', function (event) {
    var removeButton = event.target.closest('[data-rzx-remove]');
    var qtyButton = event.target.closest('[data-rzx-qty]');
    if (!removeButton && !qtyButton) return;

    var row = event.target.closest('[data-line-key]');
    if (!row) return;

    if (removeButton) {
      updateLine(row, 0, 'Removing item...');
      return;
    }

    var input = row.querySelector('[data-rzx-qty-input]');
    var delta = parseInt(qtyButton.getAttribute('data-rzx-qty'), 10) || 0;
    var current = parseInt(input && input.value, 10) || 0;
    var next = Math.max(0, current + delta);
    updateLine(row, next, 'Updating quantity...');
  });

  root.addEventListener('change', function (event) {
    if (!event.target.matches('[data-rzx-qty-input]')) return;

    var row = event.target.closest('[data-line-key]');
    var next = Math.max(0, parseInt(event.target.value, 10) || 0);
    event.target.value = next;
    updateLine(row, next, 'Updating quantity...');
  });

  root.addEventListener('keydown', function (event) {
    if (!event.target.matches('[data-rzx-qty-input]') || event.key !== 'Enter') return;
    event.preventDefault();
    event.target.blur();
  });
})();
